import { RouterConfig } from "@shared/lib/routerConfig";
import { PRIVATE_ROUTES } from "./constants";

export const isPrivateRoute = (url: string): boolean => {
    return PRIVATE_ROUTES.some((route) => route.includes(url)) && url !== RouterConfig.MAIN;
};